module.exports = __webpack_public_path__ + "img/B12-20190411_04.612e433d.jpg";